import { useViewAs } from '@/providers/ViewAsProvider';
import { Eye, X } from 'lucide-react';
import { Button } from './ui/button';

export function ViewAsIndicator() {
  const { isViewingAs, viewAsRole, setViewAsRole } = useViewAs();

  if (!isViewingAs) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-primary text-primary-foreground px-4 py-2 shadow-lg">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Eye className="h-4 w-4" />
          <span className="text-sm font-medium">
            Viewing as: <span className="font-bold capitalize">{viewAsRole}</span>
          </span>
          <span className="text-xs opacity-90">
            (You only have access to what this role can see)
          </span>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setViewAsRole(null)}
          className="h-7 gap-1 text-primary-foreground hover:bg-primary-foreground/20"
        >
          <X className="h-3 w-3" />
          Exit View
        </Button>
      </div>
    </div>
  );
}
